import React from 'react';
import { motion } from 'framer-motion';
import { Heart, MapPin, Phone, Mail, Clock, ArrowUp, Facebook, Video } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">

      <div className="footer-content">
        <div className="footer-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="footer-logo">
              <Heart size={28} className="footer-logo-icon" />
              <div>
                <h3>د. محمد خالد توفيق</h3>
                <p>استشاري النساء والتوليد</p>
              </div>
            </div>
            <p className="footer-desc">
              نقدم رعاية طبية متخصصة على أعلى مستوى في مجال النساء والتوليد
              باستخدام أحدث التقنيات العالمية في علاج تأخر الحمل والحقن المجهري.
            </p>
            {/* <div className="footer-social">
              <a href="https://www.facebook.com/share/1DGkN6yJi7/" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Facebook size={20} />
              </a>
              <a href="https://www.tiktok.com/@dr.mohamed.khaled.t?_r=1&_t=ZS-97wtDkci8aw" target="_blank" rel="noopener noreferrer" className="social-icon">
                <Video size={20} />
              </a>
            </div> */}
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>روابط سريعة</h4>
            <ul>
              <li><a href="/">الرئيسية</a></li>
              <li><a href="/about">عن الدكتور</a></li>
              <li><a href="/booking">حجز موعد</a></li>
              <li><a href="/contact">تواصل معنا</a></li>
              <li><a href="/chat">محادثة فورية</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4>معلومات التواصل</h4>
            <ul>
              <li>
                <MapPin size={16} />
                <span>المقطم: عمارة 163 بجوار صيدلية ناريمان</span>
              </li>
              <li>
                <MapPin size={16} />
                <span>مدينة نصر: 49 شارع محيي الدين عبد الحميد (ت: 01140147994)</span>
              </li>
              <li>
                <MapPin size={16} />
                <span>الدقي: مستشفى الزراعيين</span>
              </li>
              <li>
                <MapPin size={16} />
                <span>الشروق: بانوراما مول (ت: 01104044537)</span>
              </li>
              <li>
                <Phone size={16} />
                <span>واتساب الحجز العام: 01126276505</span>
              </li>
              <li>
                <Phone size={16} />
                <span>طوارئ: 01289444600</span>
              </li>
              <li>
                <Clock size={16} />
                <span>مواعيد متعددة طوال الأسبوع</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© 2026 د. محمد خالد توفيق. جميع الحقوق محفوظة.</p>
          <motion.button
            className="scroll-top-btn"
            onClick={scrollToTop}
            whileHover={{ scale: 1.1, y: -3 }}
            whileTap={{ scale: 0.9 }}
          >
            <ArrowUp size={20} />
          </motion.button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;